import React from 'react';
export const SquarePlusIcon = ({ className = '' }) => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className}`}>
      <rect width="34" height="34" transform="translate(0.296387 0.820312)" fill="black" />
      <g clipPath="url(#clip0_2071_38)">
        <path
          d="M24.6714 16.1953H17.9214V9.44531C17.9214 8.824 17.4177 8.32031 16.7964 8.32031C16.1751 8.32031 15.6714 8.824 15.6714 9.44531V16.1953H8.92139C8.30007 16.1953 7.79639 16.699 7.79639 17.3203C7.79639 17.9416 8.30007 18.4453 8.92139 18.4453H15.6714V25.1953C15.6714 25.8166 16.1751 26.3203 16.7964 26.3203C17.4177 26.3203 17.9214 25.8166 17.9214 25.1953V18.4453H24.6714C25.2927 18.4453 25.7964 17.9416 25.7964 17.3203C25.7964 16.699 25.2927 16.1953 24.6714 16.1953Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2071_38">
          <rect width="18" height="18" fill="white" transform="translate(7.79639 8.32031)" />
        </clipPath>
      </defs>
    </svg>
  );
};
const PlusIcon = ({ className = '' }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`text-[#EEEFFC] ${className}`}>
      <path
        d="M8.75 3C8.75 2.58579 8.41421 2.25 8 2.25C7.58579 2.25 7.25 2.58579 7.25 3V7.25H3C2.58579 7.25 2.25 7.58579 2.25 8C2.25 8.41421 2.58579 8.75 3 8.75H7.25V13C7.25 13.4142 7.58579 13.75 8 13.75C8.41421 13.75 8.75 13.4142 8.75 13V8.75H13C13.4142 8.75 13.75 8.41421 13.75 8C13.75 7.58579 13.4142 7.25 13 7.25H8.75V3Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PlusIcon;
